import React, { Component } from "react";
import moment from "moment";
import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Container, Spinner } from "reactstrap";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import { AvForm, AvField } from "availity-reactstrap-validation";
import toastr from 'toastr'
import Select from "react-select";
import 'toastr/build/toastr.min.css'
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl"


class AddInvoice extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 7, 'create' )){
      this.props.history.push('/dashboard')
    }
    this.state = {
      loading: false,
      selectedTransactions: [],
      breadcrumbItems: [
        { title: "Invoices", link: `/invoices/${this.props.match.params.id}` },
        { title: "Add New Invoice", link: "#" },
      ],
      TransactionGroup:[]
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }
	

    this.handleSubmit = this.handleSubmit.bind(this);    

  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push(`/invoices/${this.props.match.params.id}`)
  }

  componentDidMount(){
    this.loadItineraryCreditTrans()
    this.loadItineraryData()
  }

  async loadItineraryCreditTrans(){
    let id = this.props.match.params.id
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itinerary-credit-transactions/?itinerary__id=${id}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
              let options = []
              data.map(trans => {
                  options.push({ label: `${trans.end_user} (${moment(trans.date).format("DD-MM-YYYY")})`, value: trans.id })
                })
              
                let TransactionGroup = [
                  { 
                      label: "Transactions",
                      options: options
                  }
              ];                
                this.setState({ creditTrans:data, TransactionGroup, selectedTransactions:options })       
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  }

  async loadItineraryData(){
    let id = this.props.match.params.id
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        };
    await fetch(`${BaseUrl}/api/itineraries/itineraries/${id}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                this.setState({ itinerary: data })
                    },
                
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  

    }

  
  handleSubmit(e, values) {
    const {selectedTransactions} = this.state
    if(selectedTransactions.length > 0 ){
      this.setState({ loading: true })
      let transactions = []
      for(let i=0; i<selectedTransactions.length ; i++){
        transactions.push(selectedTransactions[i].value)
      } 
      let data = {}
      data['itinerary']= this.props.match.params.id
      data['name']= values.name
      data['email']= values.email
      data['address']= values.address
      data['phone']= values.phone
      data['date']= moment(values.date).format("YYYY-MM-DD")
      data['transactions']= transactions

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
          body: JSON.stringify(data)
          };
          fetch(`${BaseUrl}/api/invoices/invoices/`,requestOptions)
                .then(res => 
                    {if(res.status >= 400){
                        res.json()
                        .then(
                            (data) =>{  
                              console.log(data, "---data")
                              toastr.error("Something Went Wrong", "") 
                              this.setState({ loading: false })
                            }
                              
                        )
                    }
                    else{
                      toastr.success(`Invoice Created Successfully`, "") 
                      this.props.history.push(`/invoices/${this.props.match.params.id}`)
                    }    
                }
            )
    }else{
      toastr.warning("Please Add Transaction", "") 
    }

  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="" breadcrumbItems={this.state.breadcrumbItems} />
            <AvForm className="needs-validation" onValidSubmit={this.handleSubmit} >
              <Row>
                <Col xl="6">
                  <Card>
                    <CardBody> 
                      <Row>
                            <Col xs={12}>
                              
                              <h4 className="card-title">Bill To :-</h4>
                              <Row className="mb-3">
                                  <Label className="col-md-2 col-form-label" htmlFor="name">Name</Label>
                                  <Col md={6}>
                                    <AvField
                                      name="name"
                                      placeholder="Name"
                                      value = {this.state.itinerary?.customer_name}
                                      type="text"
                                      errorMessage="Enter Name"
                                      className="form-control"
                                      validate={{ required: { value: true } }}
                                      id="name"
                                    /> 
                                  </Col>
                              </Row>
                              <Row className="mb-3">
                                  <Label className="col-md-2 col-form-label" htmlFor="email">Email</Label>
                                  <Col md={6}>
                                    <AvField
                                      name="email"
                                      placeholder="Email"
                                      value = {this.state.itinerary?.email}
                                      type="email"
                                      errorMessage="Enter Email"
                                      className="form-control"
                                      validate={{ required: { value: true } }}
                                      id="email"
                                    /> 
                                  </Col>
                              </Row>
                              <Row className="mb-3">
                                  <Label className="col-md-2 col-form-label" htmlFor="address">Address</Label>
                                  <Col md={6}>
                                    <AvField
                                      name="address"
                                      placeholder="Address"
                                      type="text"
                                      value = {this.state.itinerary?.address}
                                      errorMessage="Enter Address"
                                      className="form-control"
                                      validate={{ required: { value: true } }}
                                      id="address"
                                    /> 
                                  </Col>
                              </Row>
                              <Row className="mb-3">
                                  <Label className="col-md-2 col-form-label" htmlFor="phone">Phone</Label>
                                  <Col md={6}>
                                    <AvField
                                      name="phone"
                                      placeholder="Phone"
                                      type="text"
                                      value = {this.state.itinerary?.phone}
                                      errorMessage="Enter Phone"
                                      className="form-control"
                                      validate={{ required: { value: true } }}
                                      id="phone"
                                    /> 
                                  </Col>
                              </Row>  
                             
                            </Col>
                            <hr /> 
                            <Col xs={12}>
                              
                              <Row className="mb-3">
                                <Col md="6">
                                <div className="mb-3">
                                      <Label className="form-label">Invoice For</Label>
                                      <Select 
                                          value = {this.state.selectedTransactions}
                                          onChange={(e) => this.setState({ selectedTransactions:e})}
                                          options={this.state.TransactionGroup}
                                          isMulti={true}
                                          classNamePrefix="select2-selection"
                                          id={'category'}
                                      />
                                  </div>
                                </Col> 
                                <Col md='2'></Col>
                                <Col md="4">
                                  <div className="mb-3">
                                    <Label className="form-label " htmlFor="date">Invoice Date</Label>
                                    <AvField
                                      name="date"
                                      placeholder="Invoice Date"
                                      type="date"
                                      errorMessage="Enter Invoice Date"
                                      className="form-control"
                                      validate={{ required: { value: true } }}
                                      id="date"
                                      
                                    />
                                  </div>
                                </Col> 
                              </Row>
                            </Col>  
                            
                        </Row>
                        
                                          
                        <FormGroup className="mb-0">
                          {this.state.loading?(
                            <Spinner className="me-2 mt-2" color="primary" />
                          ):(
                            <div>
                        
                          <Button type="submit" color="primary" className="me-1">
                            Create
                        </Button>{" "}
                          <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                            Cancel
                        </Button>
                        </div>
                          )}
                        
                        
                      </FormGroup>      

                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AddInvoice;



    